import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { Projects } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Projects.Pages.PROJECTS}`,
    name: Projects.Pages.PROJECTS,
    component: () => import(/* webpackChunkName: "projects" */ './views/Projects.vue'),
    meta: {
      access_roles: RouteRoles[Projects.Pages.PROJECTS],
    },
  },
  {
    path: `/${Projects.Pages.PROJECT_DETAIL}/:id`,
    name: Projects.Pages.PROJECT_DETAIL,
    beforeEnter: validateIntegerParam('id'),
    component: () => import(/* webpackChunkName: "projects" */ './views/ProjectDetail.vue'),
    meta: {
      access_roles: RouteRoles[Projects.Pages.PROJECT_DETAIL],
    },
  },
  {
    path: `/${Projects.Pages.PROJECT_NEW}`,
    name: Projects.Pages.PROJECT_NEW,
    component: () => import(/* webpackChunkName: "projects" */ './views/NewProjects.vue'),
    meta: {
      access_roles: RouteRoles[Projects.Pages.PROJECT_NEW],
    },
  },
];

export default routes;
